import { DraftStory } from "../../models";
import { formatDate, env } from "../../utils";

export default function DraftListItem({
  draftId,
  storyTitle,
  created,
  topLevelCategory,
  storyType,
  coverImage,
  isStudio,
}: DraftStory) {
  return (
    <a
      href={
        isStudio
          ? `${env("app_url")}studio/${draftId}`
          : `${env("app_url")}create/script/${draftId}`
      }
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-4 p-4 border-2 border-neutral-50 rounded-2xl bg-white shadow-md cursor-pointer hover:bg-neutral-50 no-underline text-inherit"
    >
      {coverImage ? (
        <img
          src={env("imageKit") + coverImage}
          className="w-16 h-16 rounded-lg object-cover shadow-sm flex-shrink-0"
          alt={`Cover for ${storyTitle || draftId}`}
        />
      ) : (
        <div className="w-16 h-16 rounded-lg bg-gray-200 flex items-center justify-center flex-shrink-0">
          <span className="text-gray-400 text-xs">No Image</span>
        </div>
      )}

      <div className="flex-1">
        <p className="text-2xl font-semibold">{storyTitle || draftId}</p>
        <p>Category: {topLevelCategory}</p>
        <p>created on {formatDate(created)}</p>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-500">
          {storyType === 0 ? "Book" : "Video"}
        </span>
        <span
          className={`text-sm px-2 py-1 rounded-md ${
            isStudio ? "bg-blue-100 text-blue-800" : "bg-gray-100 text-gray-800"
          }`}
        >
          {isStudio ? "From Studio" : "Not from Studio"}
        </span>
      </div>
    </a>
  );
}
